export default "__VITE_ASSET__CeqwEpsZ__"